import AddIcon from "@mui/icons-material/Add";
import PictureInPictureIcon from "@mui/icons-material/PictureInPicture";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";

import useStaffTasksV2 from "../hooks/use-staff-tasks-v2.hook";

export default function StaffTasksDrawerHeader() {
  const {
    isPatientViewMode,
    patientId,
    handleOpenTaskDrawer,
    handleOpenTaskListModal
  } = useStaffTasksV2();

  return (
    <Stack direction="row" alignItems="center" mt={1.5} ml={1} mb={1}>
      <Box flex={1}>
        <Tooltip title="Open Clinic Tasks List in Modal Window">
          <IconButton onClick={handleOpenTaskListModal}>
            <PictureInPictureIcon />
          </IconButton>
        </Tooltip>
      </Box>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="center"
        flexGrow={5}
        pr={3}
        columnGap={2}
      >
        <Box>
          <Typography
            variant="h2"
            color="textSecondary"
            sx={{
              fontSize: "24px"
            }}
          >
            {isPatientViewMode ? "Patient Tasks" : "My Tasks"}
          </Typography>
        </Box>
        <Box>
          <Button
            onClick={() =>
              handleOpenTaskDrawer(
                "create",
                isPatientViewMode ? patientId : undefined
              )
            }
            variant="outlined"
            size="small"
            startIcon={<AddIcon sx={{ mr: -0.75 }} />}
            sx={{ height: 32, width: "83px" }}
          >
            Create
          </Button>
        </Box>
      </Stack>
    </Stack>
  );
}
